/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type VideoFeedbackSource = (typeof VideoFeedbackSource)[keyof typeof VideoFeedbackSource]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VideoFeedbackSource = {
  EMBED: 'EMBED',
  VIDEO_DETAIL: 'VIDEO_DETAIL',
} as const
